import { api } from '@shared/utils/api/api.util'

const handleDownload = async (resUrl: string, fileName?: string) => {
  try {
    const response = await api(resUrl)
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url

    a.download = fileName ?? 'downloaded_file'
    document.body.appendChild(a)
    a.click()

    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('There was an error while downloading the file:', error)
  }
}

export default handleDownload
